import React, { useEffect, useRef, useState } from 'react'
import { Button, Col, Container, Row, Form } from 'react-bootstrap';
import * as Icon from "react-bootstrap-icons"
import { useDispatch, useSelector } from 'react-redux';
import Skeleton from "../../Common/Skeleton";
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import View from '../../../Assets/View.svg';
import Edit from '../../../Assets/Edit.svg';
import Delete from '../../../Assets/Delete.svg';
import { setLogout } from '../../Auth/LoginSlice';
import { setActiveKey } from '../../Common/ActiveKeySlice';
import useDebouncedApiCall from '../../Common/Reuse/Debounce';
import DeleteModel from '../../Common/Model/DeleteModel';
import PaginationSequence from '../../Common/Pagination/PaginationSequence';
import PublishModel from '../../Common/Model/PublishModel';
import UnPublishModel from '../../Common/Model/UnPublishModel';
import { categoryTypes } from '../../../Utils/GlobalConfigs';
import { setPageNo, setDocPerPage, resetData } from '../../Common/PaginationSlice';

const Category = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation();

    const userState = useSelector((state) => state?.cmsLogin?.userData.data);

    // for pagination
    const pageNo = useSelector((state) => state.pagination.pageNo);
    const docPerPage = useSelector((state) => state.pagination.docPerPage);

    // for scroll
    const { updatedCategoryId } = location.state || {};
    const dataRefs = useRef([])

    // for loader
    const [listLoader, setListLoader] = useState(false);
    const [isdelete, setIsDelete] = useState(false);

    const [deleteId, setDeleteId] = useState("");
    const [category, setCotegory] = useState("")
    const [searchField, setSearchField] = useState("");

    // for get all category data
    const [getAllCategory, setGetAllCategory] = useState([])

    // for pagination
    const [noOfPages, setNoOfPages] = useState();

    const [isPublishModalOpen, setIsPublishModalOpen] = useState(false);
    const [publishcategoryId, setPublishCategoryId] = useState(null);

    // Unpublish video variables
    const [isUnpublish, setIsUnpublish] = useState(false);
    const [unpublishId, setUnpublishId] = useState("");

    // for scroll
    const scrollToUpdatedCategory = () => {
        if (dataRefs.current[updatedCategoryId] !== undefined || dataRefs.current[updatedCategoryId] !== null) {
            console.log("Scroll To Object")
            // document.getElementById(updatedCategoryId)?.scrollIntoView({ behavior: 'smooth' });
            dataRefs.current[updatedCategoryId].scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            })
        }
    };

    useEffect(() => {
        if (dataRefs.current.length > 0) {
            scrollToUpdatedCategory();
        }
    }, [dataRefs.current]);

    // Function for handling page change
    const handlePageChange = (pageNumber) => {
        dispatch(setPageNo(pageNumber));
    };

    // Function for handling docsper page change
    const handleDocsPerPage = (docsPageProp) => {
        dispatch(setPageNo(1));
        dispatch(setDocPerPage(docsPageProp));
    };

    // Function to handle opening the publish modal
    const openPublishModal = (tagCategoryId) => {
        setPublishCategoryId(tagCategoryId);
        setIsPublishModalOpen(true);
    };

    // Function to handle opening the unpublish modal
    const openUnpublishModal = (tagCategoryId) => {
        setUnpublishId(tagCategoryId);
        setIsUnpublish(true);
    };

    // Function to handle cancelling the unpublish modal
    const closeUnpublishModal = () => {
        setIsUnpublish(false);
    };

    const handlePublishModalCancel = () => {
        setIsPublishModalOpen(false);
    };

    useEffect(() => {
        getCategory();
    }, [docPerPage, pageNo]);


    // for get category data
    const getCategory = async () => {
        setListLoader(true)
        const payload = {
            categoryType: category ? category : "",
            documentsPerPage: docPerPage,
            page: pageNo,
            title: searchField ? searchField : ""
        }
        await fetch(process.env.REACT_APP_BASE_URL + "/cms/getallcategory/filter", {
            method: "POST",
            headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${userState.token}` },
            body: JSON.stringify(payload),
        })
            .then((res) => res.json())
            .then((response) => {
                if (response.message === "Authorization failed / Forbidden") {
                    setListLoader(true);
                    dispatch(setLogout(null));
                    dispatch(setActiveKey(null));
                    localStorage.removeItem('persist:root');
                    navigate('/');
                } else {
                    setGetAllCategory(response?.data)
                    setNoOfPages(response?.data?.noOfPages);
                    setListLoader(false)
                    scrollToUpdatedCategory();
                }
            })
            .catch((error) => {
                setListLoader(false)
                console.log("error", error);
            })
    }

    // for custome hook call
    const dependencies = [category ? category : "", searchField ? searchField : ""];
    useDebouncedApiCall(getCategory, dependencies, setListLoader);

    // for delete category
    const deleteCategory = async () => {
        const payload = {
            tagCategoryId: deleteId
        }
        await fetch(process.env.REACT_APP_BASE_URL + "/tagcat/deleteTagCat", {
            method: "POST",
            headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${userState.token}` },
            body: JSON.stringify(payload),
        })
            .then((res) => res.json())
            .then((response) => {
                if (response.message === "Data deleted succussfully") {
                    toast.success("Deleted successfully.")
                    setIsDelete(false)
                    getCategory()
                }
            }).catch((error) => {
                console.log("error", error);
            })
    }

    // for toggle
    const handlePublishAction = async (tagCategoryId, isPublish) => {
        try {
            setIsPublishModalOpen(false);
            setIsUnpublish(false);

            const result = await fetch(process.env.REACT_APP_BASE_URL + "/tagcat/publishTagCat", {
                method: "POST",
                headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${userState.token}` },
                body: JSON.stringify({
                    tagCategoryId: tagCategoryId,
                    isPublish: isPublish
                }),
            });

            const response = await result.json();
            if (response) {
                getCategory();
            } else {
                console.log("Error toggling publish status");
            }
        } catch (error) {
            console.log(error);
        }
    };
    // Function to handle confirming publish modal
    const handlePublishModalConfirm = async () => {
        await handlePublishAction(publishcategoryId, true);
    };

    // Function to handle confirming unpublish modal
    const handleUnpublishConfirm = async () => {
        await handlePublishAction(unpublishId, false);
    };

    return (
        <>
            <div className="outletPadding">
                <PublishModel
                    isOpen={isPublishModalOpen}
                    onClose={handlePublishModalCancel}
                    onConfirm={handlePublishModalConfirm}
                    title="Tag Category"
                    loader={listLoader}
                />
                <UnPublishModel
                    isOpen={isUnpublish}
                    onClose={closeUnpublishModal}
                    onConfirm={handleUnpublishConfirm}
                    title="Tag Category"
                    loader={listLoader}
                />

                {/* Delete Article */}
                <DeleteModel
                    show={isdelete}
                    onHide={() => setIsDelete(false)}
                    onDelete={deleteCategory}
                    loader={listLoader}
                    label="Tag Category"
                />
                <Container>
                    <Row className="d-flex justify-content-between">
                        <Col md={4} className='mb-3 mb-md-0'>
                            <input
                                className="form-control"
                                type="text"
                                placeholder="Search here"
                                name="search"
                                value={searchField}
                                onChange={(e) => {
                                    if (e.target.value.trim()) {
                                        setSearchField(e.target.value)
                                        dispatch(setPageNo(1));
                                    } else if (e.target.value.length === 0) {
                                        setSearchField(e.target.value)
                                        dispatch(setPageNo(1));
                                    }
                                }}
                            />
                        </Col>

                        <Col md={6} className="d-flex justify-content-end align-items-center">
                            <div className='d-flex flex-row'>
                                <Form.Group className="w-100 me-4">
                                    <Form.Select
                                        value={category}
                                        onChange={(e) => {
                                            setCotegory(e.target.value);
                                            dispatch(setPageNo(1));
                                        }}>
                                        <option value="" selected>All Tag Category</option>
                                        {categoryTypes.map((itm) => (
                                            <option key={itm.value} value={itm.value}>{itm.label}</option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>

                                <Button className="primaryBtn w-100 my-auto" onClick={() => {
                                    dispatch(resetData());
                                    navigate("/dashboard/add-category")
                                }}>
                                    <Icon.PlusCircle className="me-2" size={15} />
                                    Add Tag Category
                                </Button>
                            </div>
                        </Col>

                    </Row>

                    {/* category List Table */}
                    <div className="outer-wrapper mx-auto mt-4">
                        <div className="table-wrapper" style={{ maxHeight: "68vh" }}>
                            <table>
                                <thead>
                                    <th>Sr. No.</th>
                                    <th>Tag Category Icon</th>
                                    <th>Tag Category Name</th>
                                    <th>Tag Category Type</th>
                                    <th>Publish</th>
                                    <th>Action</th>
                                </thead>
                                {listLoader ? (
                                    <Skeleton rows={10} cols={6} />
                                ) : getAllCategory?.data?.length > 0 && getAllCategory?.data !== null && getAllCategory?.data !== undefined ? (
                                    getAllCategory?.data?.map((itm, index) => {
                                        return (
                                            <tr key={itm?.tagCategoryId} ref={el => dataRefs.current[itm?.tagCategoryId] = el} id={itm?.tagCategoryId} >
                                                <td>{pageNo !== 1 ? (<>{index + 1 + docPerPage * (pageNo - 1)}</>) : (<>{index + 1}</>)}</td>
                                                <td><img src={itm?.iconURL} alt="Category Icon" width={40} /></td>
                                                <td style={{ width: "18vw" }}>{itm?.tagCategoryName}</td>
                                                <td>{itm?.categoryType}</td>
                                                <td style={{ width: '120px' }}>
                                                    {itm.isPublish ? (
                                                        <div
                                                            style={{
                                                                backgroundColor: "#8FBC8F",
                                                                borderRadius: "8px",
                                                                padding: "4px 8px",
                                                                color: "white",
                                                                textAlign: "center",
                                                                cursor: "pointer"
                                                            }}
                                                            onClick={() => openUnpublishModal(itm.tagCategoryId)}
                                                        >
                                                            Published
                                                        </div>
                                                    ) : (
                                                        <div
                                                            className="switch"
                                                            onClick={() => openPublishModal(itm.tagCategoryId)}
                                                        >
                                                            <input type="checkbox" checked={itm.publish} onChange={() => { }} />
                                                            <span className="slider round" onClick={() => openPublishModal(itm.tagCategoryId)}></span>
                                                        </div>
                                                    )}

                                                </td>
                                                <td className="d-flex">
                                                    <img src={View} alt="View" className="icon me-3"
                                                        onClick={() => navigate("/dashboard/view-category", {
                                                            state: { category: itm }
                                                        })
                                                        } />

                                                    <img src={Edit} alt="Edit" className="icon me-3"
                                                        onClick={() => navigate("/dashboard/edit-category", { state: { item: itm } })}
                                                    />

                                                    <img src={Delete} alt="Delete" className='icon'
                                                        onClick={() => {
                                                            setIsDelete(true);
                                                            setDeleteId(itm?.tagCategoryId);
                                                        }} />
                                                </td>

                                            </tr>
                                        );
                                    })
                                ) : (
                                    <p className="noDataFound">No Data Found</p>
                                )}
                            </table>
                        </div>
                    </div>

                    <PaginationSequence
                        data={getAllCategory?.count}
                        pageNo={pageNo}
                        noOfPages={noOfPages}
                        handlePageChange={handlePageChange}
                        handleDocsPerPage={handleDocsPerPage}
                        docPerPage={docPerPage}
                    />
                </Container>

            </div>
        </>
    )
}

export default Category
